import fecha from 'fecha';
import currencies from '@/constants/currencies';

const concatValues = (
  data: any = {},
  fields: string[],
  delimiter: string = ', ',
) => (
  fields.reduce((p, key) => {
    const value = data[key];
    return value ? `${p}${delimiter}${value}` : p;
  }, '')
  .substr(delimiter.length)
);

// copy only works as a result of a user action
const copyToClipboard = (str: string) => {
  // create textarea, make invisible and move outside user's view
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';

  // add textarea to body, copy contents, and remove
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const emptyChecklistItemHelper = (
  context: any,
  refKey: string,
) => {
  const elementWrapper = context.$refs[refKey].$el;

  // click on add row button and scroll to element
  !context.data[refKey].length
    && elementWrapper.querySelector('button:not([class*=ShowGuide])').click();
  hideSidebarInMobile(context);

  // focus on first empty element on next tick
  // incase it doesn't exist initially
  context.$nextTick(() => {
    const allInputs: HTMLInputElement[] = elementWrapper.querySelectorAll('input');
    const emptyInput = Array
      .from(allInputs)
      .find(element => !element.value);
    if (emptyInput) {
      setTimeout(() => emptyInput.focus(), 1000);
      return emptyInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }

    // scroll to wrapper if no input found
    elementWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  });
};

const formatCurrency = (
  amount: string|number,
  currencyCode: string,
  displayCode: boolean = true,
) => {
  const symbol = (currencies as any)[currencyCode].symbol_native;
  const formatted = (Number(amount) || 0).toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  const base = `${symbol}${formatted}`;
  return displayCode
    ? `${base} ${currencyCode}`
    : base;
};

const formatDate = (
  value: any,
  format: string = 'MMMM Do YYYY',
) => fecha.format(new Date(value), format);

const hideSidebarInMobile = (context: any) => {
  context.isMobile
  && context.$store.dispatch('chromeEditor/toggleSidebar', false);
};

const isValidEmail = (value: string) => (
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
);

const lineEq = (
  y2: number,
  y1: number,
  x2: number,
  x1: number,
  currentVal: number,
) => {
  // y = mx + b
  const m = (y2 - y1) / (x2 - x1);
  const b = y1 - m * x1;
  return m * currentVal + b;
};

const overlayElement = (
  sourceSelector: string,
  destinationSelector: string,
) => {
  const source: HTMLElement|null = document.querySelector(sourceSelector);
  const dest: HTMLElement|null = document.querySelector(destinationSelector);
  if (source && dest) {
    dest.style.position = 'relative';
    dest.appendChild(source);
  }
};

const ucfirst = (value: string = '') => (
  value.charAt(0).toUpperCase() +
  value.substr(1).toLowerCase()
);

export {
  concatValues,
  copyToClipboard,
  emptyChecklistItemHelper,
  formatCurrency,
  formatDate,
  hideSidebarInMobile,
  isValidEmail,
  lineEq,
  overlayElement,
  ucfirst,
};
